import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Paper, Stack, Typography } from '@mui/material';

import { Button, PasswordField, TextField } from '@components/base';
import useSubscriber from '@hooks/useSubscriber';

import ChooseAddressDialog from './ChooseAddressDialog';
import SwapDeviceDialog from './SwapDeviceDialog';

type SubscriberAuthProps = {
  callbackFn?: VoidFunction;
};

export const SubscriberLoginForm: FC<SubscriberAuthProps> = ({ callbackFn }) => {
  const { t } = useTranslation();

  const { handleLogin, isAuthenticating } = useSubscriber();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  return (
    <Fragment>
      <Box component={Paper} maxWidth={1} ml='auto' mr='auto' width={400}>
        <Stack
          component='form'
          onSubmit={e => {
            e.preventDefault();
            handleLogin(username, password)
              .then(callbackFn)
              .catch(({ message }) => setError(message));
          }}
          p={2}
          spacing={2}
        >
          <Box>
            <Typography align='center' gutterBottom variant='h2'>
              {t('login')}
            </Typography>

            <Typography align='center' color='text.secondary' gutterBottom variant='body2'>
              {t('subscriber.login')}
            </Typography>
          </Box>

          {error && <Alert severity='error'>{error}</Alert>}

          <TextField
            disabled={isAuthenticating}
            label={t('email')}
            onChange={({ currentTarget: { value } }) => setUsername(value)}
            required
            type='email'
            value={username}
          />

          <PasswordField
            disabled={isAuthenticating}
            onChange={({ currentTarget: { value } }) => setPassword(value)}
            value={password}
          />

          <Button loading={isAuthenticating} type='submit' variant='contained'>
            {t('logIn')}
          </Button>
        </Stack>
      </Box>

      <ChooseAddressDialog />
      <SwapDeviceDialog />
    </Fragment>
  );
};
